var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title"},[_vm._v("Purchase items (ID: "+_vm._s(_vm.$route.params.id)+")")])])
}
var staticRenderFns = []

export { render, staticRenderFns }